import { PartialExcept } from "../global-misc/misc";

export enum Eye {
  LEFT = "LEFT",
  RIGHT = "RIGHT"
}

export type MeasurementType = "Cycloplegic" | "Non-Cyclo";

export interface EyeMeasurementModel {
  id: string;
  visit_id: string;
  eyeSide: Eye;
  measurementType: string;
  sphere?: number;
  cylinder?: number;
  axis?: number;
  axialLength?: number;
  kValue?: number;
}

export interface VisitModel {
  id: string;
  date: string;
  eyeMeasurements: EyeMeasurementModel[];
}

export interface CreateEyeMeasurementModel extends Omit<EyeMeasurementModel, "id" | "visit_id"> { }
export interface CreateVisitModel extends Omit<VisitModel, "id" | "eyeMeasurements"> {
  eyeMeasurements: CreateEyeMeasurementModel[];
}

export interface UpdateEyeMeasurementModel extends PartialExcept<EyeMeasurementModel, "id"> { }
export interface UpdateVisitModel extends PartialExcept<Omit<VisitModel, "eyeMeasurements">, "id"> {
  eyeMeasurements: UpdateEyeMeasurementModel[];
}

export function getEyeFromVisit(visitData: VisitModel, eyeSide: Eye): EyeMeasurementModel {
  return visitData.eyeMeasurements.find((eyeMeasurement: EyeMeasurementModel) => eyeMeasurement.eyeSide === eyeSide)!;
}